import { Navigate, useLocation } from 'react-router-dom';

import { paths } from '@/app/router/paths';
import { useUser } from '@/features/auth/hooks/use-user';

export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const user = useUser();
  const location = useLocation();

  if (user.isLoading) {
    return <div>Loading...</div>;
  }

  if (user.error) {
    return <div>Error loading user data</div>;
  }

  const redirectUrl =
    location.pathname == paths.dashboard.path
      ? undefined
      : location.pathname + location.search;

  if (!user.data) {
    return <Navigate to={paths.auth.login.getHref(redirectUrl)} replace />;
  }

  return <>{children}</>;
};
